/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 Open Assessment Technologies SA ;
 */

/**
 * Creates a counter that will increase a counter each time a flag is changed from `true` to `false`.
 * @returns {counter}
 */
export function counterFactory() {
    let counter = 0;
    let flag = false;

    /**
     * @typedef {object} counter
     */
    return {
        /**
         * The number of counted occurrences.
         * @type {number}
         */
        get count() {
            return counter;
        },

        /**
         * Check a state and increase the internal counter if the internal flag changes from `true` to `false`.
         * @param {boolean} state
         */
        check(state = false) {
            if (flag && !state) {
                counter++;
            }
            flag = state;
        }
    };
}
